// GENERATE BY ./scripts/generate.ts
// DON NOT EDIT IT MANUALLY
import * as React from 'react';
import FontColorsOutlinedSvg from "@fishx/icons-svg/es/asn/FontColorsOutlined";
import FishxIcon from '../components/FishxIcon';

var FontColorsOutlined = function FontColorsOutlined(props, ref) {
  return React.createElement(FishxIcon, Object.assign({}, props, {
    ref: ref,
    icon: FontColorsOutlinedSvg
  }));
};

FontColorsOutlined.displayName = 'FontColorsOutlined';
export default React.forwardRef(FontColorsOutlined);


//////////////////
// WEBPACK FOOTER
// ./node_modules/@fishx/icons/es/icons/FontColorsOutlined.js
// module id = 2818
// module chunks = 0